import React from 'react';
import { PRESETS } from '../brandKits';
import { portalForHostname } from '../utils/portalExperience';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      // This boundary sits outside BrandKitProvider, so the host supplies its fallback identity.
      const portal = portalForHostname();
      const kit = portal ? PRESETS[portal.kitId] : null;
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: '20px',
          fontFamily: kit?.typography?.fontFamily || 'Arial, sans-serif',
          backgroundColor: '#f8f9fa'
        }}>
          {kit?.logos?.onLight && <img src={kit.logos.onLight} alt={portal.productName} style={{ maxWidth: 220, maxHeight: 100, objectFit: 'contain', marginBottom: 28 }} />}
          <h1 style={{ color: '#e74c3c', marginBottom: '20px' }}>Something went wrong</h1>
          <p style={{ color: '#666', marginBottom: '20px', textAlign: 'center' }}>
            The application encountered an error. Please refresh the page or contact support.
          </p>
          <button
            onClick={() => {
              this.setState({ hasError: false, error: null, errorInfo: null });
              window.location.href = '/';
            }}
            style={{
              padding: '10px 20px',
              backgroundColor: kit?.colors?.primary || '#115e59',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            Go to Home
          </button>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <details style={{ marginTop: '20px', maxWidth: '800px', width: '100%' }}>
              <summary style={{ cursor: 'pointer', color: '#666' }}>Error Details (Development Only)</summary>
              <pre style={{
                marginTop: '10px',
                padding: '10px',
                backgroundColor: '#fff',
                border: '1px solid #ddd',
                borderRadius: '5px',
                overflow: 'auto',
                fontSize: '12px'
              }}>
                {this.state.error.toString()}
                {this.state.errorInfo.componentStack}
              </pre>
            </details>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

